import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { formatarNit } from "../../../shared/helper/formatadores";
import { removeMask } from "../helper";
import { isServicoRevisarOuCancelarCTC } from "../selecaoServicos/siglaServico";

const regexCaracteresIndesejados = /([._-])/g;

export function verificaCamposAdicionaisEditaveis(campoAdicional, requerimentoTO) {
  const { tipoDocumento, sigla, bloqueavel, nome } = campoAdicional;
  const { servicoSelecionado, dadosRequerente } = requerimentoTO;

  let disabled = false;

  if (tipoDocumento === "NIT") {
    const nitPrincipal = dadosRequerente.nit;
    campoAdicional.valor = nitPrincipal;
    campoAdicional.valorComMascara = formatarNit(nitPrincipal);
    disabled = true;
  }

  if (nome && nome.toLocaleUpperCase() === "POSSUI CERTIDÃO DE NASCIMENTO?") {
    disabled = true;
  }

  if (
    servicoSelecionado.sigla === "PPDOCMED" &&
    tipoDocumento === "NB" &&
    this.props.numeroBeneficio
  ) {
    const numeroBeneficio = removeMask(this.props.numeroBeneficio);
    campoAdicional.valor = numeroBeneficio;
    campoAdicional.valorComMascara = this.props.numeroBeneficio;
    disabled = true;
  }

  if (
    servicoSelecionado.sigla === "TPU" &&
    ((this.props.falecidoDados && this.props.falecidoDados !== '') || this.props.validandoDados) &&
    (
      (sigla === 'NomeFalec' && bloqueavel) ||
      (sigla === 'DtNascFale' && bloqueavel) ||
      (sigla === 'DtObito' && bloqueavel) ||
      (sigla === 'CertObito' && bloqueavel) ||
      (sigla === 'FatoGerad' && bloqueavel)
    )
  ) {
    disabled = true;
  }

  if (
    isServicoRevisarOuCancelarCTC(servicoSelecionado.sigla) &&
    tipoDocumento === "CTC" &&
    this.props.protocoloCTC
  ) {
    const protocoloCTC = removeMask(this.props.protocoloCTC);
    campoAdicional.valor = protocoloCTC;
    campoAdicional.valorComMascara = this.props.protocoloCTC;
    disabled = true;
  }

  return disabled;
}

export function agruparCamposAdicionais(camposAdicionais, detalhar = false) {

const camposAdicionaisFiltrados = detalhar ? camposAdicionais : camposAdicionais.filter(isCampoAdicionalVisivel);

  const grupos = camposAdicionaisFiltrados
    .reduce((resultado, objeto) => {
      const grupo = objeto?.grupo?.nome || 'Outras Informações';

      if (!resultado.hasOwnProperty(grupo)) {
        resultado[grupo] = [];
      }

      resultado[grupo].push(objeto);

      return resultado;
    }, {});

  const gruposOrdenados = Object.entries(grupos)
    .sort(([aGrupo, aObjetos], [bGrupo, bObjetos]) => {
      if (aGrupo === 'Outras Informações') return 1;
      if (bGrupo === 'Outras Informações') return -1;
      const aGrupoOrdem = aObjetos[0]?.grupo?.ordem || Number.MAX_SAFE_INTEGER;
      const bGrupoOrdem = bObjetos[0]?.grupo?.ordem || Number.MAX_SAFE_INTEGER;
      return aGrupoOrdem - bGrupoOrdem; // Ordenar com base no campo ORDEM do grupo
    })
    .reduce((resultado, [grupo, objetos]) => {
      resultado[grupo] = objetos;
      return resultado;
    }, {});

    const gruposComCamposAdiconaisOrdenados = ordenarCamposAdicionaisDentroDoGrupo(gruposOrdenados); 
     
    return gruposComCamposAdiconaisOrdenados;
  }
  
  const ordenarCamposAdicionaisDentroDoGrupo = (gruposOrdenados) => {
    let gruposComCamposAdiconaisOrdenados = new Map(Object.entries(gruposOrdenados));
    gruposComCamposAdiconaisOrdenados.forEach((value, key) => {
      value.sort( (campo1, campo2) => campo1.ordem - campo2.ordem)
    });
    return Object.fromEntries(gruposComCamposAdiconaisOrdenados);
  }

export const atualizarValorCampoAdicionalPorSigla = (campos, siglaCampo, novoValor) => {
  let campoModificado = campos.find((campo) => campo.sigla === siglaCampo);
  return atualizarValorCampoAdicional(campoModificado, novoValor);
};

export const atualizarValorCampoAdicionalPorId = (campos, campoId, novoValor) => {
  let campoModificado = campos.find((campo) => campo.id === campoId);
  return atualizarValorCampoAdicional(campoModificado, novoValor);
};

const atualizarValorCampoAdicional = (campoModificado, novoValor) => {
  if (campoModificado) {
    const valorModificado = removerMascara(campoModificado, novoValor);
    campoModificado = {
      ...campoModificado,
      valorComMascara: novoValor,
      valor: valorModificado
    };
  }
  return campoModificado;
}

const removerMascara = (campo, novoValor) => {
  if (campo.mascara && !isNil(novoValor)) {
    return novoValor.toString().replace(regexCaracteresIndesejados, "");
  }
  return novoValor;
}

/* acredito que poderia otimizar usando info apenas do campo modificado */
export const atualizarVisibilidadeDosCamposAdicionais = (camposAdicionais = []) => {
  tornarCamposVisiveisParaNaoDependerDaOrdemDeConfiguracao(camposAdicionais);
  for (const campoAtual of camposAdicionais) {
    if (campoAtual.preenchidoPorIntegracao) {
      // preenchido por integracao vai ficar o que tiver sido definido pela aplicacao/desenvolvimento
      continue;
    }

    let visivel = true;
    const isFilho = campoAtual.filho;
    const isPai = campoAtual.pai;
    if (isFilho) {
      visivel = existeCampoPaiOuAssociadoVisivelOuDeIntegracao(campoAtual, camposAdicionais);
    }

    campoAtual.visivel = visivel;
    campoAtual.visivel = isCampoAdicionalVisivel(campoAtual);

    if (!visivel) {
      limparValorCampoAdicional(campoAtual);
      if (isPai) {
        esconderFilhos(campoAtual, camposAdicionais);
      }
    }
  }
}

const tornarCamposVisiveisParaNaoDependerDaOrdemDeConfiguracao = camposAdicionais => {
  camposAdicionais.forEach((campo) => {
    if (!campo.preenchidoPorIntegracao) {
      campo.visivel = true
    }
  });
}

const existeCampoPaiOuAssociadoVisivelOuDeIntegracao = (campoFilho, listaCampos) => {
  return campoFilho && listaCampos
    .filter(possivelCampoPai => isCampoAdicionalVisivel(possivelCampoPai) || possivelCampoPai.preenchidoPorIntegracao)
    .some(possivelCampoPai => isCampoAssociadoAtual(possivelCampoPai, campoFilho.id));
};

const isCampoAdicionalVisivel = (campo) =>
  campo.visivelSegurado !== false && campo.visivel;

const limparValorCampoAdicional = (campoAdicional) => {
  if (!campoAdicional.preenchidoPorIntegracao) {
    campoAdicional.valor = "";
    campoAdicional.valorComMascara = "";
  }
};

const esconderFilhos = (campoAtual, camposAdicionais) => {
  const camposFilhos = campoAtual?.camposFilhos || [];
  const camposFilhosNaoCombobox = campoAtual?.camposFilhosNaoCombobox || [];
  const idsFilhos = concatenarListaSemDuplicidade(camposFilhos, camposFilhosNaoCombobox);

  if (isEmpty(idsFilhos)) {
    return;
  }
  idsFilhos.forEach((idFilho) => {
    const campoFilho = findCampoPorId(camposAdicionais, idFilho);
    if (campoFilho) {
      const possuiPaiVisivel = existeCampoPaiOuAssociadoVisivelOuDeIntegracao(campoFilho, camposAdicionais);
      if (!possuiPaiVisivel) {
        limparValorCampoAdicional(campoFilho);
        campoFilho.visivel = false;
        if (campoFilho.pai) {
          esconderFilhos(campoFilho, camposAdicionais);
        }
      }
    }
  });
}

const concatenarListaSemDuplicidade = (primeiraLista, segundaLista) => {
  const conjunto = new Set([...primeiraLista, ...segundaLista]);
  return [...conjunto];
}

const findCampoPorId = (campos, id) => campos.find((campo) => campo.id === id);

const isCampoAssociadoAtual = (possivelCampoPai, idPossivelFilho) => {
  const isCampoAtualFilhoDeNaoCombobox = isCampoPaiDeNaoCombobox(possivelCampoPai, idPossivelFilho);
  const isCampoAtualFilhoEAssociadoDeCombobox = isCampoFilhoEAssociadoDeCombobox(possivelCampoPai, idPossivelFilho);
  return isCampoAtualFilhoDeNaoCombobox || isCampoAtualFilhoEAssociadoDeCombobox;
}

const isCampoPaiDeNaoCombobox = (possivelCampoPai, idPossivelFilho) =>
  possivelCampoPai?.camposFilhosNaoCombobox?.some((id) => id === idPossivelFilho);

const isCampoFilhoEAssociadoDeCombobox = (possivelCampoPai, idPossivelFilho) => {
  const valorSelecionado = possivelCampoPai?.valorComMascara;
  const idCampoFilhoSelecionado = valorSelecionado && possivelCampoPai.comboboxAssociados?.[valorSelecionado];
  return idPossivelFilho === idCampoFilhoSelecionado;
}
